import React from 'react';

interface BadgeProps {
  variant?: 'info' | 'accent' | 'success' | 'warning' | 'danger';
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = 'info', children, className = '' }: BadgeProps) {
  const variantClass = `badge-${variant}`;
  return <span className={`badge ${variantClass} ${className}`}>{children}</span>;
}
